import React, { useContext } from 'react';
import StyledContainer from './StyledContainer';
import StyledTitle from './StyledTitle';
import StylesContext from '../context/StylesContext';

const TopText = () => {
  const {styles} = useContext(StylesContext); 

  return (
    <StyledContainer className='top_title_container'>
      <StyledTitle
          className='top_page_title'
          $textColor={ styles.topTextColor}
        >
          Toque na parte superior da tela para iniciar
        </StyledTitle>
    </StyledContainer>
  )
}

export default TopText;